import { render, staticRenderFns } from "./ManagerIcon.vue?vue&type=template&id=3b04e1d1"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b04e1d1')) {
      api.createRecord('3b04e1d1', component.options)
    } else {
      api.reload('3b04e1d1', component.options)
    }
    module.hot.accept("./ManagerIcon.vue?vue&type=template&id=3b04e1d1", function () {
      api.rerender('3b04e1d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ManagerIcon.vue"
export default component.exports